import type { Resolver } from 'cpool-schemas';
import { schemaId } from 'cpool-schemas';
import { z } from 'zod';

type Arguments = Record<string, never>;

export const schemaPartnerResolver_GetMyPartnerContact = z.object({
    email: z.string().nullable(),
    firstName: z.string().nullable(),
    id: schemaId,
    lastName: z.string().nullable(),
    name: z.string().min(1),
    phoneE164: z.string().min(1),
});

export const schemaPartnerResolver_GetMyPartnerContacts = z.array(schemaPartnerResolver_GetMyPartnerContact);

export type SchemaPartnerResolver_GetMyPartnerContact = z.infer<typeof schemaPartnerResolver_GetMyPartnerContact>;
export type SchemaPartnerResolver_GetMyPartnerContacts = z.infer<typeof schemaPartnerResolver_GetMyPartnerContacts>;
export type PartnerResolver_GetMyPartnerContacts = Resolver<Arguments, SchemaPartnerResolver_GetMyPartnerContacts>;
